// A janela nativa do sistema operacional dispara focus/visibilitychange no retorno.
// Esses eventos não representam alteração de permissões nem mudança de contexto.
let ignoreFocusUntil = 0;

export function photoPickerOpened() {
  ignoreFocusUntil = Date.now() + 10 * 60 * 1000;
}

export function photoPickerClosed() {
  // O evento de focus pode ocorrer antes ou imediatamente após o change/cancel.
  ignoreFocusUntil = Date.now() + 3000;
}

export function shouldDeferFocusPermissionCheck() {
  return Date.now() < ignoreFocusUntil;
}
